import {
    fetchOutstandingList,
    fetchStudentContactDetail,
    fetchStudentDetsailsByPsid,
    formatContactResponse,
    getDropdowns,
    updateRemarksandReminder,
} from './utils';

import { getAppliedFilterCount } from 'modules/studentTransfer/components/searchStudent/studentTransfersListing/utils';
import moment from 'moment';
import { useCallback, useState, useEffect, useMemo } from 'react';

export const useApprovalListing = ({ filters = {} }) => {
    const [dropdownData, setDropdownData] = useState(null);
    const [outstandingList, setOutstandingList] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(filters);
    const [paginationInfo, setPaginationInfo] = useState({
        currPageNo: 0,
        currPageSize: 50,
        totalRecords: 0
    });

    const [showModelInfo, setShowModelInfo] = useState(false);
    const [selectedTab, setSelectedTab] = useState('FOLO');
    const [loading, setLoading] = useState(false)
  

    // Fetch Approval List
    const getOutstandingList = useCallback(async ({
        tabKey = selectedTab,
        filters = globalFilter,
        pageNo = paginationInfo.currPageNo,
        pageSize = paginationInfo.currPageSize,
        dropdowns = dropdownData,
    }) => {
        try {
            setSelectedTab(tabKey);
            setLoading(true);
            const filterReq = {...filters,
                programActionStatus:[tabKey],
                isToBeFollow: tabKey === "TO_BE_FOLLOW_UP",
                outstandingFrom: filters?.outstandingFrom ? moment(filters.outstandingFrom).startOf('day'): null,
                outstandingTo: filters?.outstandingTo ? moment(filters.outstandingTo).endOf('day') : null,
            }   
            
            // business not selected then set all business area in filter 
            if(!filters?.businessAreaValues?.length && dropdowns?.businessAreas?.length){
                filterReq.businessAreaValues = dropdowns.businessAreas.map(bu=>bu.value)
            }
            const resp = await fetchOutstandingList({ offset: pageNo, pageSize, filters:{...filterReq}, dropdowns });
            if (resp?.code !== 200) return;

            const { totalRecords, paginatedData, currentPage, totalPage } = resp.data || {};


            setOutstandingList(paginatedData ?? []);

            paginatedData.length>0?setPaginationInfo({
                currPageNo: currentPage,
                currPageSize: pageSize,
                totalRecords,
                totalPage
            }):setPaginationInfo(prev=>({
                ...prev,
                totalRecords: 0,
                totalPage:  0,
                currPageNo: 0,
            }));

            setGlobalFilter({
                ...filters,
                appliedFilterCount: getAppliedFilterCount(filters,['psid','applicationId','studentName'])
            });

        } catch (err) {
            console.error("Fetch Approval Requests Error:", err);
        } finally {
            setLoading(false);
        }
    }, [globalFilter, paginationInfo, dropdownData,]);


    const updateRemindersndRemarks = async (reqObj) => {
        try {
            setLoading(true);
            const { applicationId,id ,remarks, reminderDate } = reqObj
            const req = {
                mscPaymentDataId: id,
                applicationId,
                remark: remarks,
                reminderDate: reminderDate?moment(reminderDate).format("YYYY-MM-DD"):null
            }
            const resp = await updateRemarksandReminder(req);
            if (resp?.code === 200) {
                await getOutstandingList({ tabKey: selectedTab });
            }
        }
        catch (err) {
            console.error("Update Status Error:", err);
        } finally {
            setLoading(false);
        }
    }




    // Init (On Mount)
    useEffect(() => {
        const init = async () => {
            try {
                setLoading(true);

                const dropdowns = await getDropdowns();
                setDropdownData(dropdowns);
                await getOutstandingList({
                    dropdowns,
                    tabKey: 'FOLO',
                });

            } catch (err) {
                console.error("Init Error:", err);
            } finally {
                setLoading(false);
            }
        };

        init();
    }, []);

    const getStudentContactDetails = async (psid, setModelInfo)=>{
        try{
            setLoading(true)
            const [contactDetails, studentDetails] = await Promise.all([fetchStudentContactDetail(psid),fetchStudentDetsailsByPsid(psid)]);
            setModelInfo({...studentDetails,...formatContactResponse(contactDetails),});
        } catch(err){
            console.error("Fetch Student Details Error:", err); 
        }
        finally{
            setLoading(false)
        }
    }

     const tabStyle = useMemo(
        () => ({
          cursor: "pointer",
          position: "relative",
          paddingBottom: "6px",
          userSelect: "none",
        }),
        []
      );
    
      const bottomBorder = useMemo(
        () => ({
          borderBottom: "3px solid #00B0F5",
          width: "100%",
          height: "100%",
          position: "absolute",
          top: "10px",
        }),
        []
      );

    

    return {
        dropdownData,
        globalFilter,
        paginationInfo,
        outstandingList,
        selectedTab,
        showModelInfo,
        loading,
        setLoading,
        setGlobalFilter,

        setShowModelInfo,
        updateRemindersndRemarks,
        getOutstandingList,
        getStudentContactDetails,
        tabStyle,
        bottomBorder
    };
};